/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { InternalCommonCommentBaseToJSON, InternalCommonUserFromJSON, InternalUserCommentResponseV3FromJSON, InternalUserCommentsList200ResponseFromJSON, InternalUserContentRecommendationResponseCollectionV3FromJSON, InternalUserReactionsEmojiRequestV3ToJSON, InternalUserReactionsEmojiResponseCollectionV3FromJSON, InternalUserReactionsEmojiResponseV3FromJSON, InternalUserReactionsEmojiSummaryResponseV3FromJSON, } from '../models/index';
/**
 *
 */
export class UserApi extends runtime.BaseAPI {
    /**
     * Creates a new comment resource. The comment will be associated with the current user.
     * Create a new comment
     */
    internalUserCommentsCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['internalCommonCommentBase'] == null) {
                throw new runtime.RequiredError('internalCommonCommentBase', 'Required parameter "internalCommonCommentBase" was null or undefined when calling internalUserCommentsCreate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/internal/user/v3/comments`;
            const response = yield this.request({
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InternalCommonCommentBaseToJSON(requestParameters['internalCommonCommentBase']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalUserCommentResponseV3FromJSON(jsonValue));
        });
    }
    /**
     * Creates a new comment resource. The comment will be associated with the current user.
     * Create a new comment
     */
    internalUserCommentsCreate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.internalUserCommentsCreateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Deletes a comment owned by the current user. This operation cannot be undone.
     * Delete a comment
     */
    internalUserCommentsDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling internalUserCommentsDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/internal/user/v3/comments/{id}`;
            urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
            const response = yield this.request({
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a comment owned by the current user. This operation cannot be undone.
     * Delete a comment
     */
    internalUserCommentsDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.internalUserCommentsDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Returns a paginated list of comments resources. Supports ordering by votes and includes pagination metadata.
     * Get comments resources
     */
    internalUserCommentsListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['parentType'] == null) {
                throw new runtime.RequiredError('parentType', 'Required parameter "parentType" was null or undefined when calling internalUserCommentsList().');
            }
            if (requestParameters['parentId'] == null) {
                throw new runtime.RequiredError('parentId', 'Required parameter "parentId" was null or undefined when calling internalUserCommentsList().');
            }
            const queryParameters = {};
            if (requestParameters['parentType'] != null) {
                queryParameters['parent_type'] = requestParameters['parentType'];
            }
            if (requestParameters['parentId'] != null) {
                queryParameters['parent_id'] = requestParameters['parentId'];
            }
            if (requestParameters['orderByVotes'] != null) {
                queryParameters['order_by_votes'] = requestParameters['orderByVotes'];
            }
            if (requestParameters['cursor'] != null) {
                queryParameters['cursor'] = requestParameters['cursor'];
            }
            if (requestParameters['pageSize'] != null) {
                queryParameters['page_size'] = requestParameters['pageSize'];
            }
            if (requestParameters['repliesLimit'] != null) {
                queryParameters['replies_limit'] = requestParameters['repliesLimit'];
            }
            const headerParameters = {};
            let urlPath = `/internal/user/v3/comments`;
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalUserCommentsList200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * Returns a paginated list of comments resources. Supports ordering by votes and includes pagination metadata.
     * Get comments resources
     */
    internalUserCommentsList(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.internalUserCommentsListRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates a comment owned by the current user. Allows updating content, storage uploads, and attachments. Can also remove specific attachments.
     * Update a comment
     */
    internalUserCommentsUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling internalUserCommentsUpdate().');
            }
            if (requestParameters['internalCommonCommentBase'] == null) {
                throw new runtime.RequiredError('internalCommonCommentBase', 'Required parameter "internalCommonCommentBase" was null or undefined when calling internalUserCommentsUpdate().');
            }
            const queryParameters = {};
            if (requestParameters['uploadsIdsToDelete'] != null) {
                queryParameters['uploads_ids_to_delete'] = requestParameters['uploadsIdsToDelete'];
            }
            if (requestParameters['attachmentsIdsToDelete'] != null) {
                queryParameters['attachments_ids_to_delete'] = requestParameters['attachmentsIdsToDelete'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/internal/user/v3/comments/{id}`;
            urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
            const response = yield this.request({
                path: urlPath,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: InternalCommonCommentBaseToJSON(requestParameters['internalCommonCommentBase']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalUserCommentResponseV3FromJSON(jsonValue));
        });
    }
    /**
     * Updates a comment owned by the current user. Allows updating content, storage uploads, and attachments. Can also remove specific attachments.
     * Update a comment
     */
    internalUserCommentsUpdate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.internalUserCommentsUpdateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns a paginated list of content recommendations based on the provided content ID and type. The recommendations are filtered by various parameters such as content types, visibility, and score threshold. The response includes metadata for pagination and a collection of recommendations with varying attributes based on content type.
     * Get content recommendations
     */
    internalUserContentRecommendationsListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentId'] == null) {
                throw new runtime.RequiredError('contentId', 'Required parameter "contentId" was null or undefined when calling internalUserContentRecommendationsList().');
            }
            if (requestParameters['contentType'] == null) {
                throw new runtime.RequiredError('contentType', 'Required parameter "contentType" was null or undefined when calling internalUserContentRecommendationsList().');
            }
            if (requestParameters['networkId'] == null) {
                throw new runtime.RequiredError('networkId', 'Required parameter "networkId" was null or undefined when calling internalUserContentRecommendationsList().');
            }
            const queryParameters = {};
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            if (requestParameters['offset'] != null) {
                queryParameters['offset'] = requestParameters['offset'];
            }
            if (requestParameters['contentId'] != null) {
                queryParameters['content_id'] = requestParameters['contentId'];
            }
            if (requestParameters['contentType'] != null) {
                queryParameters['content_type'] = requestParameters['contentType'];
            }
            if (requestParameters['contentTypes'] != null) {
                queryParameters['content_types'] = requestParameters['contentTypes'];
            }
            if (requestParameters['createdFromGroup'] != null) {
                queryParameters['created_from_group'] = requestParameters['createdFromGroup'];
            }
            if (requestParameters['networkId'] != null) {
                queryParameters['network_id'] = requestParameters['networkId'];
            }
            if (requestParameters['path'] != null) {
                queryParameters['path'] = requestParameters['path'];
            }
            if (requestParameters['publishedAtTo'] != null) {
                queryParameters['published_at_to'] = requestParameters['publishedAtTo'].toISOString();
            }
            if (requestParameters['scoreThreshold'] != null) {
                queryParameters['score_threshold'] = requestParameters['scoreThreshold'];
            }
            if (requestParameters['visibility'] != null) {
                queryParameters['visibility'] = requestParameters['visibility'];
            }
            const headerParameters = {};
            let urlPath = `/internal/user/v3/content/recommendations`;
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalUserContentRecommendationResponseCollectionV3FromJSON(jsonValue));
        });
    }
    /**
     * Returns a paginated list of content recommendations based on the provided content ID and type. The recommendations are filtered by various parameters such as content types, visibility, and score threshold. The response includes metadata for pagination and a collection of recommendations with varying attributes based on content type.
     * Get content recommendations
     */
    internalUserContentRecommendationsList(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.internalUserContentRecommendationsListRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns the current user\'s information. Current user is the owner of the access_token used in the request.
     * Get current user information
     */
    internalUserMeRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/internal/user/v3/me`;
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalCommonUserFromJSON(jsonValue));
        });
    }
    /**
     * Returns the current user\'s information. Current user is the owner of the access_token used in the request.
     * Get current user information
     */
    internalUserMe(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.internalUserMeRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates a new emoji reaction on a parent entity. If user already reacted with the same emoji, returns the existing reaction. The reaction will be associated with the current user.
     * Create an emoji reaction
     */
    internalUserReactionsEmojisCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['internalUserReactionsEmojiRequestV3'] == null) {
                throw new runtime.RequiredError('internalUserReactionsEmojiRequestV3', 'Required parameter "internalUserReactionsEmojiRequestV3" was null or undefined when calling internalUserReactionsEmojisCreate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/internal/user/v3/reactions/emojis`;
            const response = yield this.request({
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InternalUserReactionsEmojiRequestV3ToJSON(requestParameters['internalUserReactionsEmojiRequestV3']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalUserReactionsEmojiResponseV3FromJSON(jsonValue));
        });
    }
    /**
     * Creates a new emoji reaction on a parent entity. If user already reacted with the same emoji, returns the existing reaction. The reaction will be associated with the current user.
     * Create an emoji reaction
     */
    internalUserReactionsEmojisCreate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.internalUserReactionsEmojisCreateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Deletes an emoji reaction owned by the current user. This operation cannot be undone.
     * Delete an emoji reaction
     */
    internalUserReactionsEmojisDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling internalUserReactionsEmojisDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/internal/user/v3/reactions/emojis/{id}`;
            urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
            const response = yield this.request({
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes an emoji reaction owned by the current user. This operation cannot be undone.
     * Delete an emoji reaction
     */
    internalUserReactionsEmojisDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.internalUserReactionsEmojisDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Returns a list of emoji reactions for a specific parent entity (post, comment, etc.). Includes user details and emoji definition information.
     * Get emoji reactions for a parent entity
     */
    internalUserReactionsEmojisListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['parentType'] == null) {
                throw new runtime.RequiredError('parentType', 'Required parameter "parentType" was null or undefined when calling internalUserReactionsEmojisList().');
            }
            if (requestParameters['parentId'] == null) {
                throw new runtime.RequiredError('parentId', 'Required parameter "parentId" was null or undefined when calling internalUserReactionsEmojisList().');
            }
            const queryParameters = {};
            if (requestParameters['parentType'] != null) {
                queryParameters['parent_type'] = requestParameters['parentType'];
            }
            if (requestParameters['parentId'] != null) {
                queryParameters['parent_id'] = requestParameters['parentId'];
            }
            const headerParameters = {};
            let urlPath = `/internal/user/v3/reactions/emojis`;
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalUserReactionsEmojiResponseCollectionV3FromJSON(jsonValue));
        });
    }
    /**
     * Returns a list of emoji reactions for a specific parent entity (post, comment, etc.). Includes user details and emoji definition information.
     * Get emoji reactions for a parent entity
     */
    internalUserReactionsEmojisList(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.internalUserReactionsEmojisListRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns an aggregated summary of emoji reactions grouped by emoji definition. For each emoji type, provides the total count and a limited list of recent users who reacted. Useful for displaying reaction counts with user previews (e.g., \"10 people reacted with ❤️, including John, Jane, Bob...\").
     * Get aggregated emoji reactions summary for a parent entity
     */
    internalUserReactionsEmojisSummaryRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['parentType'] == null) {
                throw new runtime.RequiredError('parentType', 'Required parameter "parentType" was null or undefined when calling internalUserReactionsEmojisSummary().');
            }
            if (requestParameters['parentId'] == null) {
                throw new runtime.RequiredError('parentId', 'Required parameter "parentId" was null or undefined when calling internalUserReactionsEmojisSummary().');
            }
            const queryParameters = {};
            if (requestParameters['parentType'] != null) {
                queryParameters['parent_type'] = requestParameters['parentType'];
            }
            if (requestParameters['parentId'] != null) {
                queryParameters['parent_id'] = requestParameters['parentId'];
            }
            if (requestParameters['emojisLimit'] != null) {
                queryParameters['emojis_limit'] = requestParameters['emojisLimit'];
            }
            const headerParameters = {};
            let urlPath = `/internal/user/v3/reactions/emojis/summary`;
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalUserReactionsEmojiSummaryResponseV3FromJSON));
        });
    }
    /**
     * Returns an aggregated summary of emoji reactions grouped by emoji definition. For each emoji type, provides the total count and a limited list of recent users who reacted. Useful for displaying reaction counts with user previews (e.g., \"10 people reacted with ❤️, including John, Jane, Bob...\").
     * Get aggregated emoji reactions summary for a parent entity
     */
    internalUserReactionsEmojisSummary(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.internalUserReactionsEmojisSummaryRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
